import { useEffect, useRef, useState } from 'react'

function useCooldown() {
  const [cooldownSeconds, setCooldownSeconds] = useState(0)
  const [isCoolingDown, setIsCoolingDown] = useState(false)
  const cooldownIntervalRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    return () => {
      if (cooldownIntervalRef.current) {
        clearInterval(cooldownIntervalRef.current)
      }
    }
  }, [])

  const startCooldown = (duration: number, onTimeout?: () => void) => {
    setIsCoolingDown(true)
    setCooldownSeconds(duration)

    if (cooldownIntervalRef.current) {
      clearInterval(cooldownIntervalRef.current)
    }

    cooldownIntervalRef.current = setInterval(() => {
      setCooldownSeconds(prevSeconds => {
        if (prevSeconds <= 1) {
          try {
            if (cooldownIntervalRef.current) {
              // to escape double rendering in StrictMode
              onTimeout?.()
            }
          } catch (error) {
            console.error('Error in cooldown timeout callback:', error)
          } finally {
            clearInterval(cooldownIntervalRef.current!)
            cooldownIntervalRef.current = null
            setIsCoolingDown(false)
          }
          return 0
        }
        return prevSeconds - 1
      })
    }, 1000)
  }

  const resetCooldown = () => {
    if (cooldownIntervalRef.current) {
      clearInterval(cooldownIntervalRef.current)
      cooldownIntervalRef.current = null
    }
    setIsCoolingDown(false)
    setCooldownSeconds(0)
  }

  return {
    timeLeft: cooldownSeconds,
    isCooling: isCoolingDown,
    startCooldown,
    resetCooldown
  }
}

export default useCooldown
